import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  Button,
} from 'reactstrap';
import { connect } from 'react-redux';
import { logout } from '../services/Auth/actions';
import icon from '../Images/pet-care.png';

class Header extends Component {
  state = {
    isOpen: false,
  }

  toggleNav = () => {
    const { isOpen } = this.state;
    this.setState({
      isOpen: !isOpen,
    });
  }

  render() {
    const {
      isOpen,
    } = this.state;
    const {
      Auth: {
        isAuthenticated,
      },
    } = this.props;

    return (
      <>
        {isAuthenticated ? (
          <Navbar light expand="md" style={{ backgroundColor: '#404040' }}>
            <>
              <Link
                to="/home"
                className="navbar-brand"
              >
                <span style={{ color: 'white' }}>
                  <img style={{ width: '40px', height: '37px', marginRight: '5px' }} src={icon} alt="logo" />
                  Vet Care Pet Clinic
                </span>
              </Link>
              <NavbarToggler onClick={this.toggleNav} />
              <Collapse isOpen={isOpen} navbar>
                <Nav navbar className="ml-auto">
                  <NavItem>
                    <Link
                      to="/add-client"
                      className="navbar-brand"
                      onClick={this.toggleNav}
                    >
                      <Button color="primary">
                        Add Client
                      </Button>
                    </Link>
                  </NavItem>
                  <NavItem>
                    <Link
                      to="/pet-list"
                      className="navbar-brand"
                      onClick={this.toggleNav}
                    >
                      <Button color="primary">
                        Pet List
                      </Button>
                    </Link>
                  </NavItem>
                  <NavItem onClick={() => { this.props.logout(); }}>
                    <Link
                      to="/"
                      className="navbar-brand"
                      onClick={this.toggleNav}
                    >
                      <Button color="danger">
                        Logout
                      </Button>
                    </Link>
                  </NavItem>
                </Nav>
              </Collapse>
            </>
          </Navbar>
        ) : (
          <Navbar light expand="md" style={{ backgroundColor: '#404040' }}>
            <>
              <Link
                to="/"
                className="navbar-brand"
              >
                <span style={{ color: 'white' }}>
                  <img style={{ width: '40px', height: '37px', marginRight: '5px' }} src={icon} alt="logo" />
                  Vet Care Pet Clinic
                </span>
              </Link>
              <NavbarToggler onClick={this.toggleNav} />
              <Collapse isOpen={isOpen} navbar>
                <Nav navbar className="ml-auto">
                  <p className="text-white p-2">
                    Ph: +91-20-25679175
                  </p>
                  <p className="text-white p-2">
                    drapte.vetcare@gmail.com
                  </p>
                  <NavItem>
                    <Link
                      to="/login"
                      onClick={this.toggleNav}
                    >
                      <Button color="primary">
                        Admin Login
                      </Button>
                    </Link>
                  </NavItem>
                </Nav>
              </Collapse>
            </>
          </Navbar>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  Auth: state.Auth,
});

const mapDispatchToProps = {
  logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
